import { combineReducers } from 'redux';
// import { datePickerReducer } from '~base/date-picker/date-picker';
import authReducer from '~client/reducers/auth';
import bookingsReducer from '~reducers/bookings';
import paymentReducer from '~reducers/payment';
import ordersReducer from '~reducers/longtail-bookings';
import withdrawalReducer from '~reducers/withdrawal';
import propertiesReducer from '~reducers/properties';
import pmsReducer from '~reducers/pms-reducers';
import reconciliationReducer from '~reducers/reconciliation';

const reducer = combineReducers({
  auth: authReducer,
  bookings: bookingsReducer,
  payment: paymentReducer,
  withdrawal: withdrawalReducer,
  properties: propertiesReducer,
  // datePicker: datePickerReducer,
  orders: ordersReducer,
  pmsReducer,
  reconciliationReducer,
});

export default reducer;
